import React, { Component } from 'react';
import BarTitle from "../../components/BarTitle/index";
import Painel from "../../components/Painel";
//import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, PieChart, Pie, Cell, LineChart, Line, AreaChart, Area } from 'recharts';
import './dashboard.css';

//Grafico 1
const data = [
    { name: 'Jan', '2024': 350, '2025': 480 },
    { name: 'Feb', '2024': 220, '2025': 430 },
    { name: 'Mar', '2024': 350, '2025': 860 },
];

//Grafico 2
const statusData = [
    { name: 'Entregues', value: 100 },
    { name: 'Em andamento', value: 15 },
    { name: 'Cancelados', value: 5 },
];
const COLORS = ['#4ecb84', '#f3ed65', '#ff7373' ];

//Grafico 3
const pedidosSemana = [
    { dia: 'Qui', pedidos: 90 },
    { dia: 'Sex', pedidos: 200 },
    { dia: 'Sáb', pedidos: 250 },
    { dia: 'Dom', pedidos: 220 },
    { dia: 'Seg', pedidos: 30 },
    { dia: 'Ter', pedidos: 45 },
    { dia: 'Qua', pedidos: 100 },
];

//Grafico 4
const faturamentoMensal = [
    { mes: 'Jan', valor: 12000 },
    { mes: 'Fev', valor: 15000 },
    { mes: 'Mar', valor: 18000 },
    { mes: 'Abr', valor: 17000 },
    { mes: 'Mai', valor: 21000 },
];

class DashBoard extends Component {
    render() {
        return (
            <div>
                <BarTitle name="Dashboard" />
                <div className="wrapper-md">
                    <Painel title="Acompanhamento Estratégico ">
                        <div className="charts-grid">
                            <div className="chart-item">
                                <h4>Corridas em Relação Ano Anterior</h4>
                                {/*<BarChart width={600} height={350} data={data}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="name" />
                                    <YAxis />
                                    <Tooltip />
                                    <Legend />
                                    <Bar dataKey="2024" fill="#ffa66b" />
                                    <Bar dataKey="2025" fill="#f3ed65" />
                                </BarChart>*/}
                            </div>
                            <div className="chart-item">
                                <h4>Status Corridas Hoje</h4>
                                {/*<PieChart width={400} height={350}>
                                    <Pie
                                        data={statusData}
                                        cx={200}
                                        cy={175}
                                        innerRadius={60}
                                        outerRadius={120}
                                        fill="#8884d8"
                                        paddingAngle={5}
                                        dataKey="value"
                                        label
                                    >
                                        {statusData.map((entry, index) => (
                                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                        ))}
                                    </Pie>
                                     <Legend />
                                </PieChart>*/}
                            </div>
                            <div className="chart-item">
                                <h4>Corridas na Semana</h4>
                                {/*<LineChart width={600} height={350} data={pedidosSemana}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="dia" />
                                    <YAxis />
                                    <Tooltip />
                                    <Legend />
                                    <Line type="monotone" dataKey="pedidos" stroke="#293a78" strokeWidth={3} />
                                </LineChart>*/}
                            </div>
                            <div className="chart-item">
                                <h4>Transações Recebidas via Pix(R$)</h4>
                                {/*<AreaChart width={600} height={350} data={faturamentoMensal}>
                                    <defs>
                                        <linearGradient id="colorValor" x1="0" y1="0" x2="0" y2="1">
                                            <stop offset="5%" stopColor="#4ecb84" stopOpacity={0.8} />
                                            <stop offset="95%" stopColor="#4ecb84" stopOpacity={0} />
                                        </linearGradient>
                                    </defs>
                                    <XAxis dataKey="mes" />
                                    <YAxis />
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <Tooltip />
                                    <Area type="monotone" dataKey="valor" stroke="#82ca9d" fillOpacity={1} fill="url(#colorValor)" />
                                </AreaChart>*/}
                            </div>
                        </div>
                    </Painel>
                </div>
            </div>
        );
    }
}

export default DashBoard;



// WEBPACK FOOTER //
// ./src/views/DashBoard/index.js